import { ApplicationName } from '@models/context/application-name';
import { Product } from '@models/context/product';

export const environment = {
  production: true,
  realProduction: false,
  prodDatabase: false,
  keycloak: {
    issuer: 'https://id.dev.myroad.unif.app/realms/humanroads',
    clientId: 'gps-dev',
    adminClientId: 'backoffice-dev',
    showDebugInformation: false
  },
  analyticsEnvironment: 'dev',
  adventureUri: '/apis/adventure',
  poiUri: '/apis/poi',
  hostSuffix: {
    [Product.Explore]: 'explore.dev.myroad.unif.app',
    [Product.Connect]: 'connect.dev.myroad.unif.app',
    [ApplicationName.MyRoad]: 'dev.myroad.unif.app',
    [ApplicationName.Oraccle]: "oraccle.explore.dev.myroad.unif.app",
    [ApplicationName.CmqBtpNumerique]: 'cmq-btp-numerique.explore.dev.myroad.unif.app',
    [Product.Show]: 'salon.dev.myroad.unif.app',
    [ApplicationName.RegionSud]: 'region-sud.explore.dev.myroad.unif.app'
  },
  protocol: 'https://',
  resolveHost(): string {
   const host = window.location.hostname;
   // Handle dev environment root domain
   if (host === 'dev.myroad.unif.app') {
     return 'oraccle.explore.dev.myroad.unif.app';
   }
   return host;
  }
};
